module.exports = __webpack_public_path__ + "static/img/prize-bg.2d871c66.png";